import { CSSProperties, useEffect, useState } from 'react'
import { AnimatedUnderline, SlimUnderline, WideUnderline } from './Underline'
import { Link, Pathname } from 'i18n/routing'
import { cx } from 'lib/cx'

export function MenuItem({
  href,
  children,
  active,
  style,
  className,
  variant = 'default',
}: {
  href: Pathname
  children: string
  active?: boolean
  style?: CSSProperties
  className?: string
  variant?: 'default' | 'cta'
}) {
  const [isClicked, setClicked] = useState(false)

  useEffect(() => {
    // Use setTimeout to avoid synchronous setState in effect
    setTimeout(() => {
      setClicked(false)
    }, 0)
  }, [active])

  return (
    <li role="none" onClick={() => setClicked(true)} style={style}>
      <Link
        href={href as any}
        role="menuitem"
        aria-current={active ? 'true' : undefined}
        className={cx(
          variant === 'cta' &&
            'border-2 rounded-full text-black hover:text-white uppercase py-[18px] px-20 text-12 font-bold bg-headerCtaBg border-headerCtaBorder lg:bg-headerCtaBgDesktop lg:border-headerCtaBorderDesktop lg:hover:bg-headerCtaBorderDesktop',
          className,
        )}
      >
        <span className="relative group pb-12">
          {children}
          {variant === 'default' && (
            <span className="absolute bottom-[0.4rem] left-0 right-0">
              <AnimatedUnderline isActive={active || isClicked}>
                {children.length > 7 ? <WideUnderline /> : <SlimUnderline />}
              </AnimatedUnderline>
            </span>
          )}
        </span>
      </Link>
    </li>
  )
}
